import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import TestimonialForm from "./TestimonialForm";

const API_BASE =
  (typeof import.meta !== "undefined" &&
    import.meta.env &&
    import.meta.env.VITE_API_URL) ||
  process.env.REACT_APP_API_BASE ||
  "/backend";

const TestimonialSlider = () => {
  const [testimonios, setTestimonios] = useState([]);
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  // Cargar testimonios
  useEffect(() => {
    const fetchTestimonios = async () => {
      try {
        const res = await fetch(
          `${API_BASE}/api/obtener_testimonios.php?t=${Date.now()}`,
          { cache: "no-store" }
        );
        const text = await res.text();
        const json = JSON.parse(text);
        const items = Array.isArray(json) ? json : json?.data || [];
        setTestimonios(items);
        setIndex(0);
      } catch (e) {
        console.error("Error al obtener testimonios:", e);
      }
    };
    fetchTestimonios();
  }, []);

  // Autoplay (pausa on hover)
  useEffect(() => {
    if (!testimonios.length || paused) return;
    const id = setInterval(
      () => setIndex((i) => (i + 1) % testimonios.length),
      5000
    );
    return () => clearInterval(id);
  }, [testimonios.length, paused]);

  const prev = () =>
    setIndex((i) => (i - 1 + testimonios.length) % testimonios.length);
  const next = () => setIndex((i) => (i + 1) % testimonios.length);

  const handleNewTestimonial = (nuevo) => {
    setTestimonios((prev) => [nuevo, ...prev]);
    setIndex(0);
  };

  const current = testimonios[index];

  return (
    <section className="py-16 bg-black text-white">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold text-[#FFD700] text-center mb-12">
          Testimonios de nuestros clientes
        </h2>

        <div
          className="relative max-w-3xl mx-auto"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          {/* Flechas */}
          {testimonios.length > 1 && (
            <>
              <button
                aria-label="Anterior"
                onClick={prev}
                className="absolute -left-3 top-1/2 -translate-y-1/2 z-10 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 w-10 h-10 grid place-items-center"
              >
                ‹
              </button>
              <button
                aria-label="Siguiente"
                onClick={next}
                className="absolute -right-3 top-1/2 -translate-y-1/2 z-10 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 w-10 h-10 grid place-items-center"
              >
                ›
              </button>
            </>
          )}

          {/* Slide */}
          <div className="overflow-hidden h-72">
            <AnimatePresence mode="wait">
              {current && (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: 80 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -80 }}
                  transition={{ duration: 0.6 }}
                  className="h-full w-full bg-[#1a1a1a] rounded-xl shadow-lg p-8 flex flex-col items-center text-center"
                >
                  {/* avatar arriba */}
                  <img
                    src={`${API_BASE}${current.avatar}`}
                    alt={current.nombre}
                    className="w-16 h-16 rounded-full border-2 border-[#FFD700] mb-4 object-cover"
                  />
                  {/* texto */}
                  <p className="text-gray-300 italic mb-4 text-lg leading-relaxed">
                    “{current.mensaje}”
                  </p>
                  <span className="font-semibold text-[#FFD700] mt-auto">
                    {current.nombre}
                  </span>
                </motion.div>
              )}
            </AnimatePresence>

            {!current && (
              <div className="h-full grid place-items-center text-gray-400">
                No hay testimonios aún.
              </div>
            )}
          </div>

          {/* Puntos (bullets) */}
          {testimonios.length > 1 && (
            <div className="flex justify-center gap-2 mt-4">
              {testimonios.map((_, i) => (
                <button
                  key={i}
                  aria-label={`Ir al testimonio ${i + 1}`}
                  onClick={() => setIndex(i)}
                  className={`w-3 h-3 rounded-full transition-transform ${
                    i === index
                      ? "bg-[#FFD700] scale-110"
                      : "bg-white/30 hover:bg-white/50"
                  }`}
                />
              ))}
            </div>
          )}
        </div>

        {/* Formulario */}
        <div className="mt-12 max-w-xl mx-auto">
          <TestimonialForm onNewTestimonial={handleNewTestimonial} />
        </div>
      </div>
    </section>
  );
};

export default TestimonialSlider;


